import { createSpreadDefinition } from '../internal/builders.js';
export const SINGLE_CARD_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'single-card',
    name: 'Carta Singola',
    slug: 'single-card',
    category: 'core',
    description: 'Una sola carta per domande rapide, centratura e pratica quotidiana.',
    ritual_note: 'Respira una volta, formula la domanda e lascia che il segnale emerga senza sovraccarico.',
    opening_invocation: null,
    closing_words: null,
    difficulty: 'beginner',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'single',
    intent: ['daily', 'clarity', 'open'],
    semantic_tags: ['diagnostic', 'self-study'],
    layout_id: 'single-1',
    position_specs: [
        {
            role_id: 'message',
            name: 'Segnale',
            description: 'Quale corrente domina adesso, senza mediazioni?',
        },
    ],
    keywords: ['quotidiano', 'rapido', 'centratura', 'messaggio'],
    recommended_for_questions: [
        'Quale tono domina questa giornata?',
        'Su cosa devo portare attenzione immediata?',
    ],
    contraindications: ['Non ideale quando servono molte variabili o confronto tra opzioni.'],
    focus_mode_ids: [],
    ritual_intensity: 1,
});
export const PAST_PRESENT_FUTURE_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'past-present-future',
    name: 'Passato / Presente / Futuro',
    slug: 'past-present-future',
    category: 'core',
    description: 'Grammatica base della timeline: da dove vieni, cosa è attivo, dove tende il flusso.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'beginner',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'triad',
    intent: ['timeline', 'clarity', 'open'],
    semantic_tags: ['temporal', 'forecast', 'self-study'],
    layout_id: 'linear-3',
    position_specs: [
        {
            role_id: 'past',
            description: 'Quale memoria o evento continua a parlare nel presente?',
        },
        {
            role_id: 'present',
            description: 'Quale soglia è attiva ora?',
        },
        {
            role_id: 'future',
            description: 'Verso quale direzione tende il campo se non viene corretto?',
        },
    ],
    keywords: ['timeline', 'transizione', 'sequenza', 'chiarezza'],
    recommended_for_questions: [
        'Come si è formato questo nodo?',
        'Quale direzione sta prendendo la situazione?',
    ],
    contraindications: ['Non ideale per letture relazionali complesse o domande con molte opzioni.'],
    focus_mode_ids: [],
    ritual_intensity: 1,
});
export const SITUATION_ACTION_OUTCOME_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'situation-action-outcome',
    name: 'Situazione / Azione / Esito',
    slug: 'situation-action-outcome',
    category: 'core',
    description: 'Triade pratica per capire il campo, intervenire e leggere la probabile conseguenza.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'beginner',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'triad',
    intent: ['clarity', 'decision', 'open'],
    semantic_tags: ['causal', 'decision', 'diagnostic'],
    layout_id: 'linear-3',
    position_specs: [
        {
            role_id: 'situation',
            description: 'Che cosa sta succedendo davvero sotto il rumore?',
        },
        {
            role_id: 'action',
            description: 'Quale gesto, correzione o rinuncia chiede il momento?',
        },
        {
            role_id: 'outcome',
            description: 'Quale esito si consolida se agisci in questo modo?',
        },
    ],
    keywords: ['azione', 'chiarezza', 'pratico', 'esito'],
    recommended_for_questions: [
        'Quale passo è più utile adesso?',
        'Come posso intervenire senza disperdere energia?',
    ],
    contraindications: ['Non ideale per letture rituali profonde o per cicli temporali lunghi.'],
    focus_mode_ids: [],
    ritual_intensity: 1,
});
export const CELTIC_CROSS_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'celtic-cross',
    name: 'Croce Celtica',
    slug: 'celtic-cross',
    category: 'core',
    description: 'Lettura classica ampia: diagnosi, attrito, asse profondo, coscienza e traiettoria.',
    ritual_note: 'Richiede tempo, silenzio e disponibilità a leggere tensioni parallele senza fretta.',
    opening_invocation: 'Apro la croce delle correnti e consento al quadro di mostrarsi intero.',
    closing_words: 'Chiudo la croce, raccolgo il quadro e trattengo solo ciò che è vivo.',
    difficulty: 'advanced',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'cross',
    intent: ['clarity', 'timeline', 'decision', 'open'],
    semantic_tags: ['diagnostic', 'causal', 'forecast', 'self-study'],
    layout_id: 'celtic-cross-10',
    position_specs: [
        {
            role_id: 'situation',
            name: 'Cuore della questione',
            description: 'Quale tema occupa il centro reale della lettura?',
        },
        {
            role_id: 'obstacle',
            name: 'Croce',
            description: 'Quale attrito taglia o blocca il centro?',
        },
        {
            role_id: 'past',
            name: 'Radice recente',
            description: 'Che cosa sta ancora premendo da dietro?',
        },
        {
            role_id: 'future',
            name: 'Soglia imminente',
            description: 'Quale svolta si avvicina con più forza?',
        },
        {
            role_id: 'hidden',
            name: 'Sotterraneo',
            description: 'Quale motivazione inconscia o fattore non visto sostiene il quadro?',
        },
        {
            role_id: 'advice',
            name: 'Sopra',
            description: 'Che cosa la coscienza può scegliere di fare o capire?',
        },
        {
            role_id: 'self',
            name: 'Sé',
            description: 'In che postura si trova il consultante rispetto al tema?',
        },
        {
            role_id: 'other',
            name: 'Ambiente',
            description: 'Che cosa risponde dall’esterno o dal contesto?',
        },
        {
            role_id: 'challenge',
            name: 'Speranze e timori',
            description: 'Quale desiderio ambiguo o paura plasma l’interpretazione?',
        },
        {
            role_id: 'outcome',
            name: 'Esito',
            description: 'Quale forma tende a stabilizzarsi se il campo resta com’è?',
        },
    ],
    keywords: ['classico', 'profondo', 'diagnosi', 'quadro completo'],
    recommended_for_questions: [
        'Voglio vedere il quadro completo senza comprimere la complessità.',
        'Questa situazione ha troppi livelli per una triade semplice.',
    ],
    contraindications: [
        'Non consigliata per domanda rapidissima o daily.',
        'Non ideale se il consultante non ha tempo di seguire tutti i livelli della lettura.',
    ],
    focus_mode_ids: [],
    ritual_intensity: 3,
});
export const HORSESHOE_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'horseshoe',
    name: 'Ferro di Cavallo',
    slug: 'horseshoe',
    category: 'core',
    description: 'Arco diagnostico che accompagna dal quadro iniziale alla tendenza finale.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'horseshoe',
    intent: ['clarity', 'timeline', 'relationship', 'open'],
    semantic_tags: ['temporal', 'diagnostic', 'forecast'],
    layout_id: 'horseshoe-7',
    position_specs: [
        { role_id: 'past', description: 'Quale eco passata apre l’arco?' },
        { role_id: 'present', description: 'Che cosa è già in moto adesso?' },
        { role_id: 'hidden', description: 'Che cosa lavora dietro il visibile?' },
        { role_id: 'obstacle', description: 'Dove si concentra l’attrito maggiore?' },
        { role_id: 'advice', description: 'Quale correzione di rotta è possibile?' },
        { role_id: 'resource', description: 'Quale forza alleata può sostenerti?' },
        { role_id: 'outcome', description: 'Quale esito si delinea a chiusura dell’arco?' },
    ],
    keywords: ['arco', 'diagnostico', 'processo', 'lettura ampia'],
    recommended_for_questions: [
        'Voglio una lettura intermedia più ricca di una triade.',
        'Mi serve capire il processo e non solo il punto d’arrivo.',
    ],
    contraindications: ['Non ideale per domanda binaria o confronto stretto fra opzioni.'],
    focus_mode_ids: [],
    ritual_intensity: 2,
});
export const DAILY_TRIAD_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'daily-triad',
    name: 'Stesa Quotidiana',
    slug: 'daily-triad',
    category: 'core',
    description: 'Triade mobile-first per rito breve: tono, compito, integrazione del giorno.',
    ritual_note: 'Usala al mattino o prima di una soglia quotidiana, senza inseguire predizioni assolute.',
    opening_invocation: null,
    closing_words: null,
    difficulty: 'beginner',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'triad',
    intent: ['daily', 'clarity'],
    semantic_tags: ['self-study', 'ritual', 'diagnostic'],
    layout_id: 'balanced-3',
    position_specs: [
        {
            role_id: 'message',
            name: 'Tono del giorno',
            description: 'Quale qualità chiede attenzione oggi?',
        },
        {
            role_id: 'action',
            name: 'Compito',
            description: 'Quale gesto concreto renderà il giorno più allineato?',
        },
        {
            role_id: 'integration',
            name: 'Chiusura',
            description: 'Quale consapevolezza conviene portare a sera?',
        },
    ],
    keywords: ['daily', 'ritmo', 'mattino', 'pratica'],
    recommended_for_questions: [
        'Come entro bene in questa giornata?',
        'Quale tono devo incarnare oggi?',
    ],
    contraindications: ['Non ideale per domande storiche, annuali o di forte complessità relazionale.'],
    focus_mode_ids: [],
    ritual_intensity: 2,
});
export const SHADOW_BASE_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'shadow-base',
    name: 'Stesa Ombra base',
    slug: 'shadow-base',
    category: 'core',
    description: 'Ingresso controllato nel shadow work con ferita, attrito e integrazione.',
    ritual_note: 'Procedi lentamente e sospendi il bisogno di dare una risposta definitiva.',
    opening_invocation: 'Nomino l’ombra senza violentarla e accolgo ciò che emerge.',
    closing_words: 'Richiudo il varco e porto con me solo ciò che posso integrare ora.',
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['shadow', 'healing'],
    semantic_tags: ['shadow-work', 'healing', 'introspective'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'shadow', description: 'Quale ombra prende forma oggi?' },
        { role_id: 'wound', description: 'Quale ferita la nutre?' },
        { role_id: 'obstacle', description: 'Che cosa ne impedisce il riconoscimento limpido?' },
        { role_id: 'ritual_action', description: 'Quale gesto può contenere il processo senza reprimerlo?' },
        { role_id: 'integration', description: 'Come può essere integrato il materiale emerso?' },
    ],
    keywords: ['ombra', 'guarigione', 'introspezione', 'lavoro interiore'],
    recommended_for_questions: [
        'Perché sto reagendo sempre allo stesso modo?',
        'Quale materiale rimosso chiede ascolto?',
    ],
    contraindications: ['Non ideale per domande puramente pratiche o quando serve una risposta immediata e binaria.'],
    focus_mode_ids: [],
    ritual_intensity: 3,
});
export const OPTION_A_OPTION_B_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'option-a-option-b',
    name: 'Scelta tra opzioni',
    slug: 'option-a-option-b',
    category: 'core',
    description: 'Confronto chiaro tra due vie con consiglio e traiettoria finale.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'beginner',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['decision', 'clarity'],
    semantic_tags: ['decision', 'causal', 'diagnostic'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'situation', description: 'Qual è il nodo che rende necessaria la scelta?' },
        { role_id: 'option_a', description: 'Che qualità ha la prima via?' },
        { role_id: 'option_b', description: 'Che qualità ha la seconda via?' },
        { role_id: 'advice', description: 'Che cosa andrebbe considerato prima di decidere?' },
        { role_id: 'outcome', description: 'Quale traiettoria generale appare più coerente?' },
    ],
    keywords: ['decisione', 'bivio', 'confronto', 'scelta'],
    recommended_for_questions: [
        'Quale opzione è più coerente con quello che sto vivendo?',
        'Sto scegliendo per chiarezza o per paura?',
    ],
    contraindications: ['Non ideale quando le opzioni sono più di due o il nodo è ancora troppo grezzo.'],
    focus_mode_ids: [],
    ritual_intensity: 1,
});
export const RELATIONSHIP_TWO_POLARITIES_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'relationship-two-polarities',
    name: 'Relazione a due polarità',
    slug: 'relationship-two-polarities',
    category: 'core',
    description: 'Stesa a sei carte per leggere due poli, il legame, la frizione e la possibilità di integrazione.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['relationship', 'clarity', 'healing'],
    semantic_tags: ['relational', 'conflict', 'diagnostic'],
    layout_id: 'custom-grid-6',
    position_specs: [
        { role_id: 'self', description: 'Che cosa porto io nel legame?' },
        { role_id: 'other', description: 'Che cosa porta l’altra polarità?' },
        { role_id: 'bond', description: 'Quale collante o tensione tiene insieme il campo?' },
        { role_id: 'challenge', description: 'Dove si addensa lo scontro o la distanza?' },
        { role_id: 'resource', description: 'Quale risorsa condivisa può sostenere il rapporto?' },
        { role_id: 'integration', description: 'Quale forma di equilibrio è realisticamente disponibile?' },
    ],
    keywords: ['relazione', 'polarità', 'coppia', 'dinamica'],
    recommended_for_questions: [
        'Che cosa accade davvero tra me e l’altra persona?',
        'Dove nasce la tensione fra noi?',
    ],
    contraindications: ['Non ideale per leggere il futuro assoluto della relazione come verdetto fisso.'],
    focus_mode_ids: ['relationship-tension'],
    ritual_intensity: 2,
});
export const ANNUAL_WHEEL_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'annual-wheel',
    name: 'Annuale / 12 mesi',
    slug: 'annual-wheel',
    category: 'core',
    description: 'Ruota annuale con significatore e dodici mesi, pensata per cicli lunghi e pianificazione rituale.',
    ritual_note: 'Usa questa stesa solo quando sei disposto a tenere un diario del ciclo e a rileggerla nel tempo.',
    opening_invocation: 'Apro il ciclo dei dodici passaggi e chiedo visione senza rigidità.',
    closing_words: 'Richiudo l’anno simbolico e lascio spazio alla revisione mese dopo mese.',
    difficulty: 'advanced',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'wheel',
    intent: ['yearly', 'timeline', 'spiritual'],
    semantic_tags: ['forecast', 'temporal', 'ritual', 'self-study'],
    layout_id: 'annual-wheel-13',
    position_specs: [
        { role_id: 'significator', description: 'Quale asse governa l’intero anno simbolico?' },
        { role_id: 'month_1' },
        { role_id: 'month_2' },
        { role_id: 'month_3' },
        { role_id: 'month_4' },
        { role_id: 'month_5' },
        { role_id: 'month_6' },
        { role_id: 'month_7' },
        { role_id: 'month_8' },
        { role_id: 'month_9' },
        { role_id: 'month_10' },
        { role_id: 'month_11' },
        { role_id: 'month_12' },
    ],
    keywords: ['annuale', 'mesi', 'ciclo', 'visione lunga'],
    recommended_for_questions: [
        'Quali soglie principali mi attendono nel prossimo ciclo?',
        'Come si distribuisce l’anno a livello simbolico e pratico?',
    ],
    contraindications: [
        'Non consigliata se vuoi solo un check rapido.',
        'Non ideale se non intendi rileggere la stesa nel corso dei mesi.',
    ],
    focus_mode_ids: ['yearly-milestones', 'yearly-thresholds'],
    ritual_intensity: 4,
});
export const CORE_SPREAD_DEFINITIONS = [
    SINGLE_CARD_SPREAD_DEFINITION,
    PAST_PRESENT_FUTURE_SPREAD_DEFINITION,
    SITUATION_ACTION_OUTCOME_SPREAD_DEFINITION,
    CELTIC_CROSS_SPREAD_DEFINITION,
    HORSESHOE_SPREAD_DEFINITION,
    DAILY_TRIAD_SPREAD_DEFINITION,
    SHADOW_BASE_SPREAD_DEFINITION,
    OPTION_A_OPTION_B_SPREAD_DEFINITION,
    RELATIONSHIP_TWO_POLARITIES_SPREAD_DEFINITION,
    ANNUAL_WHEEL_SPREAD_DEFINITION,
];
//# sourceMappingURL=core.js.map